<p-toast position="bottom-right"></p-toast>
<p-confirmDialog appendTo="body"></p-confirmDialog>
<app-archive-sidebar class="archive-form">
  <app-archive-tasks-button bottom [origins]="[origin]"
                            [buttonTitle]="'page.profile.report.tasks.form'"></app-archive-tasks-button>
  <span body class="cc-header form-buttons">
    <span class="cc-title">
    {{'page.' + this.transPartKey + '.title' | translate}}
    </span>
    <span class="cc-buttons">
      <p-toggleButton onIcon="fas fa-check" offIcon="fas fa-times"
                      [(ngModel)]="forceDayValue"
                      [disabled]="formLoading || settingsFormLoadingProgressValue<100"
                      [onLabel]="'page.' + transPartKey + '.button.force_previous_day' | translate"
                      [offLabel]="'page.' + transPartKey + '.button.force_previous_day' | translate"
                      (onChange)="forceDay()"
      >
      </p-toggleButton>
      <p-toggleButton onIcon="fas fa-check" offIcon="fas fa-times"
                      [(ngModel)]="useProfiles"
                      [disabled]="formLoading || settingsFormLoadingProgressValue<100"
                      [onLabel]="'page.' + transPartKey + '.button.use_profiles' | translate"
                      [offLabel]="'page.' + transPartKey + '.button.use_profiles' | translate"
                      (onChange)="setUseProfiles(); ccForm.reloadFieldValueMap()"
      >
      </p-toggleButton>
      <i class="fa fa-diamond vertical-middle font-small-dot"></i>
      <button pButton pRipple (click)="executePreview()" type="button"
              class=" p-button-sm p-button-success p-button-text"
              icon="fas fa-play" [pTooltip]="'page.' + transPartKey + '.button.execute' | translate"
              [disabled]="!validateForm() || formLoading || settingsFormLoadingProgressValue<100"
      ></button>
      <button pButton pRipple (click)="download()" type="button" class=" p-button-sm p-button-info p-button-text"
              icon="fas fa-file-download" [pTooltip]="'page.' + transPartKey + '.button.download' | translate"
              [disabled]="!validateForm() || formLoading || settingsFormLoadingProgressValue<100"
      ></button>
    </span>
  </span>
      <span body class="form-filter">
          <app-cc-form #ccForm [transPartKey]="transPartKey"
                       [loading]="formLoading" [submitted]="formSubmitted"
                       [formConfig]="formConfig"
                       [(formRecord)]="formRecord" (formRecordChange)="formRecordChanged($event)"
                       [loadingProgressValue]="settingsFormLoadingProgressValue"
                       [globalErrorMessage]="globalErrorMessage" (sizeChanged)="refreshTableHeight()"
          ></app-cc-form>
      </span>
      <p-tabView body #ccTabView *ngIf="reportFormTabs.length>1" [scrollable]="false">
        <p-tabPanel *ngFor="let reportFormTab of reportFormTabs; let i = index" [header]="reportFormTab.tab">
          <cc-readonly-table #cctable [transPartKey]="transPartKey" [tableConfig]="reportFormTab.tableConfig"
                             [records]="reportFormTab.records" [totalRecords]="reportFormTab.totalRecords"
                             [loading]="tableLoading"
                             [scrollHeight]="tableHeight"
          ></cc-readonly-table>
        </p-tabPanel>
      </p-tabView>
      <cc-readonly-table body #cctable *ngIf="reportFormTabs.length==1" #tableResult [transPartKey]="transPartKey" [tableConfig]="reportFormTabs[0].tableConfig"
                         [records]="reportFormTabs[0].records" [totalRecords]="reportFormTabs[0].totalRecords"
                         [loading]="tableLoading"
                     [scrollHeight]="tableHeight"
      ></cc-readonly-table>

</app-archive-sidebar>

